import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Page from './components/Page';
import Home from './pages/Home';

// Lazy load non-critical routes for code splitting
const About = React.lazy(() => import('./pages/About'));
const Services = React.lazy(() => import('./pages/Services'));
const Blog = React.lazy(() => import('./pages/Blog'));
const Works = React.lazy(() => import('./pages/Works'));
const Contact = React.lazy(() => import('./pages/Contact'));
const MakeUpConsultation = React.lazy(() => import('./pages/MakeUpConsultation'));
const WomansDay = React.lazy(() => import('./pages/WomansDay'));
const NotFound = React.lazy(() => import('./pages/NotFound'));

const SPRITE_ID = 'svg-sprite';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSprite();
  }

  componentWillUnmount() {
    this.cleanupSprite();
  }

  fetchSprite = async () => {
    if (document.getElementById(SPRITE_ID)) return;
    const text = await fetch(`${process.env.PUBLIC_URL}/spritemap.svg`).then(data => data.text());
    const div = document.createElement('div');
    div.id = SPRITE_ID;
    div.style.display = 'none';
    div.innerHTML = text;
    const root = document.getElementById('root');
    document.body.insertBefore(div, root);
  };

  cleanupSprite = () => {
    const sprite = document.querySelector(`#${SPRITE_ID}`);
    if (sprite) {
      document.body.removeChild(sprite);
    }
  };

  render() {
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Page>
          <Suspense fallback={<div />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/rolam" element={<About />} />
              <Route path="/szolgaltatasok/egyeni-sminktanacsadas" element={<MakeUpConsultation />} />
              <Route path="/szolgaltatasok" element={<Services />} />
              <Route path="/blog/*" element={<Blog />} />
              <Route path="/munkak/*" element={<Works />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/nonap" element={<WomansDay />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Page>
      </Router>
    );
  }
}

export default App;
